import React from "react";

const CreditDebitDetailsForm = ({ setSubDetailsModal, setInvoice }) => {
  const handleInvoice = () => {
    setSubDetailsModal(false);
    setInvoice(true);
  };
  return (
    <div className="w-[70%]">
      <p className="text-[14px] text-[#828282] mt-4">Card Number</p>
      <input
        type="text"
        placeholder="Enter the card number"
        className="text-[16px] border w-full border-[#95C2FF] p-2 rounded-lg"
      />
      <p className="text-[14px] text-[#828282] mt-4">
        Name (as appear on the card)
      </p>
      <input
        type="text"
        placeholder="Enter the name as on the card"
        className="text-[16px] border w-full border-[#95C2FF] p-2 rounded-lg"
      />
      <div className="flex justify-between">
        <div className="w-[48%]">
          <p className="text-[14px] text-[#828282] mt-4">Expiry Date</p>
          <input
            type="text"
            placeholder="MM/DD"
            className="text-[16px] border w-full border-[#95C2FF] p-2 rounded-lg"
          />
        </div>
        <div className="w-[48%]">
          <p className="text-[14px] text-[#828282] mt-4">CVV</p>
          <input
            type="password"
            placeholder="Enter the CVV number"
            className="text-[16px] border w-full border-[#95C2FF] p-2 rounded-lg"
          />
        </div>
      </div>
      <p className="text-[14px] text-[#828282] mt-4">
        Company/Organization (Optional)
      </p>
      <input
        type="text"
        placeholder="Enter the company name"
        className="text-[16px] border w-full border-[#95C2FF] p-2 rounded-lg"
      />
      <p className="text-[14px] text-[#828282] mt-4">GST (Optional)</p>
      <input
        type="text"
        placeholder="Enter the GST number"
        className="text-[16px] border w-full border-[#95C2FF] p-2 rounded-lg"
      />
      <p className="text-[14px] text-[#828282] mt-4">Address</p>
      <input
        type="text"
        placeholder="Enter the address here"
        className="text-[16px] border w-full border-[#95C2FF] p-2 rounded-lg"
      />

      <div className="flex justify-between">
        <div className="w-[48%]">
          <p className="text-[14px] text-[#828282] mt-4">City</p>
          <input
            type="text"
            placeholder="Enter the city"
            className="text-[16px] border w-full border-[#95C2FF] p-2 rounded-lg"
          />
        </div>
        <div className="w-[48%]">
          <p className="text-[14px] text-[#828282] mt-4">ZIP Code</p>
          <input
            type="text"
            placeholder="Enter the code"
            className="text-[16px] border w-full border-[#95C2FF] p-2 rounded-lg"
          />
        </div>
      </div>

      <div className="flex justify-between">
        <div className="w-[48%]">
          <p className="text-[14px] text-[#828282] mt-4">State</p>
          <input
            type="text"
            placeholder="Enter the state"
            className="text-[16px] border w-full border-[#95C2FF] p-2 rounded-lg"
          />
        </div>
        <div className="w-[48%]">
          <p className="text-[14px] text-[#828282] mt-4">Country</p>
          <input
            type="text"
            placeholder="Enter the country"
            className="text-[16px] border w-full border-[#95C2FF] p-2 rounded-lg"
          />
        </div>
      </div>

      <div className="flex justify-between text-[14px] mt-4">
        <div className="border border-[#2F80ED] w-[49%] p-2 rounded-lg flex justify-center cursor-pointer">
          <button>Discord</button>
        </div>
        <div
          className="bg-[#2F80ED] text-white w-[49%] p-2 rounded-lg flex justify-center cursor-pointer"
          onClick={handleInvoice}
        >
          <button>Save</button>
        </div>
      </div>
    </div>
  );
};

export default CreditDebitDetailsForm;
